// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".canvasBox[data-v-525ff28a]{width:100%;position:absolute;top:0;left:0;z-index:5;overflow:hidden}#canvas[data-v-525ff28a]{height:100%}", ""]);
// Exports
module.exports = exports;
